import { ICON_TYPES } from './iconTypes';

export default {
	workspace: {
		name: 'home-group',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Workspace',
	},
	publicChannel: {
		name: 'workspaces-outline',
		type: ICON_TYPES.materialIcons,
		text: 'Channel',
	},
	privateChannel: {
		name: 'comments',
		type: ICON_TYPES.fontAwesome5,
		text: 'Chat',
	},
	annotate: { // MaterialCommunityIcons has a bunch if I need add/delete consistancy
		name: 'comment',
		type: ICON_TYPES.fontAwesome5,
		text: 'Notes',
	},
	send: {
		name: 'send',
		type: ICON_TYPES.ionicon,
		text: 'Send',
	},
	sent: {
		name: 'ios-checkmark-done',
		type: ICON_TYPES.ionicon,
		text: 'Sent',
	},
	sendFailed: {
		name: 'alert-outline',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Failed',
	},
	messagePlus: {
		name: 'message-plus',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Message',
	},
	messages: {
		name: 'comments',
		type: ICON_TYPES.fontAwesome5,
		text: 'Messages',
	},
	annotations: {
		name: 'notes-medical',
		type: ICON_TYPES.fontAwesome5,
		text: 'Notes',
	},
	leaveConversation: {
		name: 'logout',
		type: ICON_TYPES.materialIcons,
		text: 'Leave',
	},
	transcript: {
		name: 'file-text-o',
		type: ICON_TYPES.fontAwesome,
		text: 'Transcript',
	},
};